import React, { useLayoutEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import tw from "tailwind-styled-components";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import { Text } from "@components";
import theme from "../../theme";

const FooterText = (props) => {
  return (
    <div className={footerText}>
      <ArrowForwardIosIcon
        sx={{ color: theme.colors.buttonColor, height: "12px", width: "12px" }}
      />
      <Text
        className={`${text} hover:opacity-100 hover:underline underline-offset-2`}
      >
        {props.children}
      </Text>
    </div>
  );
};

const SocialButton = ({ item }) => {
  let name = item.split(".");
  name = name?.[1];
  let Logo = null;
  switch (name) {
    case "facebook":
      Logo = FacebookOutlinedIcon;
      break;
    case "instagram":
      Logo = InstagramIcon;
      break;
    case "linkedin":
      Logo = LinkedInIcon;
      break;
    case "youtube":
      Logo = YouTubeIcon;
      break;
  }
  const [focus, setFocus] = useState(false);
  return (
    <a href={item} target="_blank" rel="noreferrer">
      <div
        onMouseEnter={() => setFocus(true)}
        onMouseLeave={() => setFocus(false)}
        className="flex items-center justify-center h-12 w-12 rounded-full bg-white hover:cursor-pointer shadow-[0px_1px_7px_0px_rgb(180,172,255)] hover:bg-[#e7e8e9]"
      >
        <Logo
          sx={{
            // color: focus ? theme.colors.logoGray : theme.colors.blue54,
            width: "25px",
            height: "25px",
          }}
        />
      </div>
    </a>
  );
};

const styles = {
  footerContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "full",
    height: "auto",
    backgroundColor: theme.colors.bgFooter,
  },
};

const Footer = () => {
  const { t } = useTranslation("common");
  const data = useSelector((state) => state?.headerReducer);
  const { logo } = useSelector((state) => state.headerReducer);
  const { setting } = useSelector((store) => store.settingsReducer);
  const logoPath = logo?.data?.logo?.url;
  const {
    address,
    email,
    phone,
    facebook,
    instagram,
    linkedInn,
    youtube,
    zestLogo,
  } = setting?.data || {};

  const [FooterNav, setFooterNav] = useState([]);

  useLayoutEffect(() => {
    if (data?.menus?.data?.length > 0) {
      const filterMenu = data?.menus?.data?.filter(
        (val, ind) => val?.slug !== "header-nav"
      );

      let orderWise = _.orderBy(filterMenu, ["slug"], ["asc"]);
      setFooterNav(orderWise);
    }
  }, [data]);

  return (
    <div style={styles.footerContainer}>
      <MainView>
        <div className={`container mx-auto ${FooterContainer}`}>
          {FooterNav && (
            <FooterDiv className="lg:w-2/5 w-full">
              <div className="w-full mb-2">
                <img
                  src={logoPath}
                  className="md:h-16 h-10 object-contain"
                  alt=""
                />
              </div>
              {address && <Text className={addressText}>{address}</Text>}
              {phone && (
                <div className="w-full">
                  <Text className={phoneText}>{phone}</Text>
                </div>
              )}
              {email && (
                <div className="w-full">
                  <a
                    href={`mailto:${email}`}
                    className="hover:cursor-pointer hover:underline underline-offset-2"
                  >
                    <Text className={emailText}>{email}</Text>
                  </a>
                </div>
              )}
            </FooterDiv>
          )}
          <div className={`container mx-auto ${FooterContainerRight}`}>
            <div className={`container mx-auto ${FooterContainerRightTop}`}>
              {FooterNav?.map((item, index) => {
                const FooterNav2 = item?.items;
                return (
                  <FooterDiv key={index}>
                    <FooterTitle>{item?.title}</FooterTitle>
                    {FooterNav2.map((items, key) => {
                      return (
                        <NavLink
                          key={key}
                          to={items?.url}
                          target={String(items?.target)}
                        >
                          <FooterText>{items?.title}</FooterText>
                        </NavLink>
                      );
                    })}
                  </FooterDiv>
                );
              })}
            </div>
          </div>
        </div>
        <div className="flex flex-col container mx-auto md:flex-row justify-between px-10 md:px-0">
          <div className="flex items-center gap-4 md:gap-3 justify-center md:justify-start">
            {facebook && <SocialButton item={facebook} />}
            {instagram && <SocialButton item={instagram} />}
            {linkedInn && <SocialButton item={linkedInn} />}
            {youtube && <SocialButton item={youtube} />}
          </div>
          {zestLogo?.url && (
            <div className="flex md:flex-row items-center md:gap-4 justify-center md:justify-start mt-3 md:mt-0">
              <Text className=" text-blackText text-7 opacity-70 hidden md:block">
                {t("footer.poweredBy")}
              </Text>
              <img src={zestLogo?.url} className="w-[200px] h-auto" alt="" />
            </div>
          )}
        </div>
      </MainView>
    </div>
  );
};

const MainView = tw.div`
w-full
h-auto
pb-6
md:pb-10
md:px-10
`;

const FooterDiv = tw.div`
w-fit
min-w-[200px]
h-auto
flex
flex-col
items-start
justify-start
gap-y-2
`;

const FooterTitle = tw.span`
text-[1.125rem]
font-semibold
text-blackText
text-md
`;

const text = `
text-[16px]
text-blackText
opacity-70
`;

const emailText = `
text-[16px]
text-blackText
font-medium
`;

const phoneText = `
text-[16px]
text-blackText
font-medium
`;

const addressText = `
text-[17px]
text-blackText
opacity-70
font-semibold
`;

const FooterContainer = `
w-full
h-auto
bg-bgFooter 
flex
xl1:flex-row
flex-col
justify-between
items-start
gap-x-2
gap-y-6
pt-6
pb-4
md:px-0 px-4`;

const FooterContainerRight = `
w-full
h-auto
bg-bgFooter 
flex
flex-col
flex-wrap
justify-between
items-start
gap-x-6
gap-y-4
md:gap-y-20
xl1:px-4 px-0
`;

const FooterContainerRightTop = `
w-full
h-auto
bg-bgFooter 
pb-8
flex
lg:flex-row flex-col
items-start
lg:justify-between justify-start
gap-x-2 gap-y-6
`;

const footerText = `
flex
flex-row
items-center
gap-[3px]
no-underline
hover:underline
decoration-white
underline-offset-4
hover:cursor-pointer`;

export default Footer;
